import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import PendingApproval from "./PendingApproval";

interface Props {
  children: ReactNode;
}

const RequireApproval = ({ children }: Props) => {
  const { user, loading, isApproved, approvalLoading } = useAuth();

  if (loading || approvalLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!isApproved) {
    return <PendingApproval />;
  }

  return <>{children}</>;
};

export default RequireApproval;
